<template>
  <Modal v-model="visible" :title="formData.id ? '编辑佣金政策文件' : '新增佣金政策文件'" width="720" :mask-closable="false" :closable="!submitLoading">
    <Form v-if="visible" ref="formRef" :model="formData" :label-width="100" :disabled="submitLoading">
      <FormItem label="文件名称" prop="fileName" :rules="{ required: true, whitespace: true, message: '请输入文件名称', trigger: 'blur' }">
        <Input v-model="formData.fileName" placeholder="请输入文件名称" :maxlength="200" show-word-limit />
      </FormItem>
      <FormItem
        label="政策文件"
        prop="fileUrl"
        :rules="[$units.formRule.required('请上传政策文件'), { max: 500, message: '文件地址不能超过500个字符', trigger: 'change' }]"
      >
        <upload-file v-model="files" private-upload fileType="many" :maxUploadLength="1" showFileName :disabled="submitLoading" @change="fileChange" />
        <div class="form-tip">支持 PDF、Excel、Word、PPT、JPG、PNG，每次上传一个文件。</div>
      </FormItem>
      <FormItem label="可见级别" prop="visibleLevel" :rules="$units.formRule.required('请选择可见级别', 'change', 'number')">
        <template slot="label">可见级别<visible-level-help /></template>
        <RadioGroup v-model="formData.visibleLevel">
          <Radio v-for="item in visibleLevelOptions" :key="item.value" :label="item.value">{{ item.label }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="排序" prop="sortNo" :rules="{ type: 'integer', min: -2147483648, max: 2147483647, message: '请输入有效的整数', trigger: 'change' }">
        <InputNumber v-model="formData.sortNo" :precision="0" :min="-2147483648" :max="2147483647" />
        <span class="form-tip sort-tip">数值越小越靠前，默认为0</span>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input v-model="formData.remark" type="textarea" :rows="4" :maxlength="500" show-word-limit placeholder="请输入备注" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :disabled="submitLoading" @click="visible = false">取消</Button>
      <Button type="primary" :loading="submitLoading" @click="submit">保存</Button>
    </div>
  </Modal>
</template>

<script>
import { common } from '@/api/mixins';
import uploadFile from '@/components/commons/uploadNew2';
import visibleLevelHelp from './visibleLevelHelp';
import { visibleLevelOptions, getVisibleLevels, getFileType } from '../index.config';

export default {
  name: 'IfaCommissionFileEditModal',
  mixins: [common],
  components: { uploadFile, visibleLevelHelp },
  data() {
    return {
      visible: false,
      submitLoading: false,
      visibleLevelOptions,
      files: [],
      formData: {}
    };
  },
  methods: {
    open(row = {}) {
      const levels = getVisibleLevels(row);
      this.formData = {
        id: row.id || '',
        fileName: row.fileName || '',
        fileUrl: row.fileUrl || '',
        fileType: getFileType(row),
        visibleLevel: levels.length === 1 ? levels[0] : '',
        sortNo: row.sortNo == null ? 0 : row.sortNo,
        remark: row.remark || ''
      };
      this.files = row.fileUrl ? [{ path: row.fileUrl, fileName: row.fileName }] : [];
      this.visible = true;
      this.clearValidate('formRef');
    },
    fileChange(files) {
      const file = files[0];
      this.formData.fileUrl = file ? file.path : '';
      this.formData.fileType = file ? getFileType(file) : '';
      if (file && !this.formData.fileName.trim()) this.formData.fileName = (file.fileName || '').slice(0, 200);
      this.$refs.formRef.validateField('fileUrl');
    },
    submit() {
      if (this.submitLoading) return;
      this.$refs.formRef.validate(valid => {
        if (!valid || this.submitLoading) return;
        this.submitLoading = true;
        const { id, fileName, fileUrl, fileType, visibleLevel, sortNo, remark } = this.formData;
        const data = {
          fileName: fileName.trim(),
          fileUrl,
          fileType,
          visibleLevels: String(visibleLevel),
          sortNo: sortNo == null ? 0 : sortNo,
          remark: remark.trim()
        };
        if (id) data.id = id;
        this.$http({ url: '/buz/ifaCommissionFile/save', type: 'POST', data })
          .then(() => {
            this.$notice.success(id ? '编辑成功' : '新增成功');
            this.visible = false;
            this.$emit('success');
          })
          .catch(() => {})
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-tip {
  color: #999;
  font-size: 12px;
}
.sort-tip {
  margin-left: 12px;
}
</style>
